import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { AuthLayout } from '#features/auth/auth-layout.tsx'
import { authClient } from '#features/auth/auth-service.ts'

export const Route = createFileRoute('/_auth')({
  validateSearch: z.object({
    // Only allow internal paths to prevent open redirects
    redirectTo: z
      .string()
      .optional()
      .transform((value) =>
        value?.startsWith('/') && !value.startsWith('//') ? value : undefined,
      ),
    invite_code: z.string().optional(),
  }),
  beforeLoad: async ({ search, location }) => {
    // A reset token authorizes this form independently of an existing session.
    if (location.pathname === '/reset-password') {
      document.body.classList.add('loaded')
      return
    }
    const session = await authClient.getSession()

    if (session.data?.session) {
      throw redirect({
        to: search.redirectTo ?? '/',
        reloadDocument: search.redirectTo?.startsWith('/api/integrations/'),
      })
    }

    document.body.classList.add('loaded')
  },
  component: () => (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  ),
})
